import { ApiClientError as E, RequestCancelledError as c, NetworkError as i } from "../errors/errors.js";
import "../errors/utils.js";
const a = /* @__PURE__ */ new Set(["AbortError", "TimeoutError"]), u = "GET", T = (t, e, s) => {
  if (t instanceof E)
    return t;
  const o = e instanceof Request ? e : void 0, r = (s?.method ?? o?.method ?? u).toUpperCase(), n = o?.url ?? e.toString();
  return a.has(t.name) ? new c(r, n, { cause: t }) : t instanceof TypeError ? new i(r, n, { cause: t }) : t;
};
export {
  T as toTransportError
};
//# sourceMappingURL=to-transport-error.js.map
